<script>
import { Affix } from 'vue-affix'

export default {
  props: {
    images: {
      type: Array,
      default: () => []
    },
    selected: {
      type: [String, Number],
      default: null
    }
  },
  components: {
    Affix
  },
  methods: {
    navigateTo(id) {
      this.$scrollTo(`#image-${id}`, {
        duration: 1,
        offset: -105
      })
    }
  }
}
</script>

<template>
  <div class="gallery">
    <div class="gallery-large">
      <template v-for="image in images">
        <button
          :key="image.id"
          :class="[
            {
              'is-picked': selected === image.id,
              'is-predicted': image.isAfter
            },
            'image'
          ]"
          @click="$emit('select', image.id)"
          :id="`image-${image.id}`"
          v-test="{ image: image.id }"
        >
          <img :src="image.path" :width="image.width" :height="image.height" />
          <div class="image-label">
            <div class="image-text">Select image</div>
            <div class="image-check">
              <svg class="icon icon--yuge"><use xlink:href="#check"></use></svg>
            </div>
          </div>
          <div class="image-tag" v-if="image.isAfter">
            <svg class="icon icon--yuge"><use xlink:href="#tag"></use></svg>
          </div>
        </button>
      </template>
    </div>

    <div class="gallery-small">
      <affix
        class="thumbContainer"
        relative-element-selector=".gallery-large"
        :offset="{ top: 100, bottom: 0 }"
      >
        <template v-for="image in images">
          <button
            :key="image.id"
            :class="[
              {
                'is-picked': selected === image.id,
                'is-predicted': image.isAfter
              },
              'thumb'
            ]"
            @click="navigateTo(image.id)"
          >
            <img :src="image.path" width="160" height="120" />

            <div class="thumb-check">
              <svg class="icon icon--xl"><use xlink:href="#check"></use></svg>
            </div>
            <div class="thumb-tag" v-if="image.isAfter">
              <svg class="icon icon--xl"><use xlink:href="#tag"></use></svg>
            </div>
          </button>
        </template>
      </affix>
    </div>
  </div>
</template>

<style lang="scss">
@import '@/styles/_functions.scss';
@import '@/styles/_settings.scss';

.gallery {
  display: flex;
  justify-content: center;
  padding-top: 5px;
}

.gallery-large {
  flex: 1 1 auto;
  padding-bottom: 40px;
  padding-top: 5px;
}

.gallery-small {
  flex: 0 0 200px;
  margin-left: 10px;
}

.image,
.thumb {
  display: block;
  padding: 0;
  margin: 0;
  border: 0;

  img {
    display: block;
  }
}

$focus-shadow: $gray-500 0 0 0 1px;
$selection-shadow: rgba($green, 0.75) 0 0 0 3px;
$prediction-shadow: rgba($brand-blue, 0.75) 0 0 0 3px;

.image {
  position: relative;
  border: 5px solid white;
  border-radius: $border-radius;

  & + & {
    margin-top: 25px;
  }

  img {
    width: 100%;
    height: auto;
    max-width: max-content;
  }

  &:focus {
    outline: none;
    box-shadow: $focus-shadow;

    // &.is-predicted {
    //   box-shadow: $prediction-shadow, $focus-shadow;
    // }

    // &.is-picked {
    //   box-shadow: $selection-shadow, $focus-shadow;
    // }
  }

  // &.is-predicted {
  //   box-shadow: $prediction-shadow;
  // }

  // &.is-picked {
  //   box-shadow: $selection-shadow;
  // }
}

.image-label {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: $font-size-lg;
  z-index: 1;

  display: flex;
  align-items: center;
  opacity: 0;
  transition: opacity 0.1s linear;

  color: white;

  .image:hover & {
    opacity: 1;
  }
}

.image-text {
  display: block;
  padding-right: 15px;
  text-shadow: 1px 2px rgba(black, 0.5);
}

.image-check {
  padding: 4px;
  background: rgba(black, 0.5);
  border-radius: 50%;
  .icon {
    display: block;
    padding: 4px;
  }
}

.image-tag {
  position: absolute;
  bottom: 20px;
  right: 20px;
  color: white;

  padding: 6px 4px 2px 4px;
  background: $brand-blue;
  box-shadow: 0 2px 0 0 rgba(black, 0.5);
  border-radius: 50%;
  .icon {
    display: block;
    padding: 4px;
  }
}

.image.is-picked {
  .image-text {
    display: none;
  }

  .image-label {
    padding: 0;
    background: none;
    opacity: 1;
  }

  .image-check {
    background: $green;
    box-shadow: 0 2px 0 0 rgba(black, 0.5);
  }
}

.thumbContainer {
  width: 200px;
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  padding: 5px 0;
}

.thumb {
  position: relative;
  background: #ddd;
  border: 4px solid white;
  // margin: 0 auto;
  margin-left: 5px;
  border-radius: $border-radius;

  & + & {
    margin-top: 15px;
  }

  &:focus {
    outline: none;
    box-shadow: $focus-shadow;

    &.is-predicted {
      box-shadow: $prediction-shadow, $focus-shadow;
    }

    &.is-picked {
      box-shadow: $selection-shadow, $focus-shadow;
    }
  }

  &.is-predicted {
    box-shadow: $prediction-shadow;
  }

  &.is-picked {
    box-shadow: $selection-shadow;

    .thumb-check {
      display: block;
    }
  }
}

.thumb-check {
  position: absolute;
  top: 10px;
  right: 10px;
  display: none;
  padding: 4px;
  color: white;
  background: $green;
  border-radius: 50%;
  box-shadow: 0 2px 0 0 rgba(black, 0.5);

  .icon {
    display: block;
  }
}

.thumb-tag {
  position: absolute;
  bottom: 10px;
  right: 10px;
  // display: none;
  padding: 6px 4px 2px 4px;
  color: white;
  background: $brand-blue;
  border-radius: 50%;
  box-shadow: 0 2px 0 0 rgba(black, 0.5);

  .icon {
    display: block;
  }
}
</style>
